import { ViewName } from '../ui/tools/constants';

export interface IAccount {
  key: any;
}

export const defaultValue: Readonly<IAccount> = {
  key: null,
};

export class ViewConfigResponse {
  nextView: any;
}

export class SubscriptionCriteria {
  imei: string;
  tel: string;
  iban: string;
  email: string;
  number: string;
  startDate: any;
  lastName: string;
  firstName: string;
  codePostal: string;
  mineSubscription: boolean;
}
export class ContactValid {
  public email: string;
  public phone: string;
  public lastName: string;
  public firstName: string;

  constructor(phone, email, firstName, lastName) {
    this.phone = phone || '';
    this.email = email || '';
    this.lastName = lastName || '';
    this.firstName = firstName || '';
  }
}

// export class GlobalObject {
//   subscriptionsNotAttachement?: [];
//   currentView?: any = "";
//   foundSubscription?: any = null;
//   moreSubscription?: boolean = false;
//   notMineSubscription?: boolean = false;
//   subscriptionVerifed?: boolean = false;
//   maxTry?: boolean = false;
//   maxVerifTry?: boolean = false;
//   notCriteriaForVerifed?: boolean = false;
//   previousContactAdministrator?: boolean = false;
//   notMatchedVerifTries?: Map<string, boolean> =
//     new Map([
//       ["imei", true],
//       ["email", true],
//       ["iban", true],
//       ["sms", true]
//     ]);
// }

export class GlobalObject {
  subscriptionsNotAttachement?: [];
  currentView?: any = '';
  productCode?: string;
  viewPayload = new Map<string, any>([
    [ViewName.EFFECTIVE_VIEW, {}],
    [ViewName.CONTACT_GESTIONNAIRE, {}],
    [ViewName.SUBSCRIPTION_ACCOUNT_SEARCH, {}],
    [ViewName.EMAIL_ACCOUNT_ATTACHEMENT, {}],
    [ViewName.MOBILE_NO_MATCHED_CONTACT, {}],
    [ViewName.HOME, {}],
    [ViewName.VERIF_SUBSCRIPTION_PROCESS, {}],
  ]);
}
